/** Angular */
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatPaginatorIntl } from '@angular/material/paginator';
/** Externals */
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
/** Sixense */
import { DsLibLoginFormModule } from '@sixense/ds-lib-login-form';
import { DsLibCommonModule, DsLibSnackbarModule, TRANSLATIONS } from '@sixense/ds-lib-common';
import { BydLocalStorage, BydTranslateLoaderFactory, TRANSLATIONS_TOKEN } from '@sixense/ds-lib-utils';
import { BydRuntimeModule, BydRuntimeService } from '@sixense/byd-lib-runtime';
import { BydCoreServiceModule, BYD_API_INJECTION_TOKEN } from '@sixense/byd-core-service';
import { BydAuthInterceptorService } from '@sixense/byd-auth-service';
import { BydTranslateModule } from '@sixense/byd-lib-translate';
/** Resolvers */
/** Service */
import { DsErrorsInterceptorService } from '@core/interceptors/ds-errors-interceptor.service';
import { DsLoaderInterceptorService } from '@core/interceptors/ds-loader-interceptor.service';
import { DsPaginatorService } from '@shared/services/ds-paginator.service';
/** Modules */
import { AppModuleRouting } from './app-module.routing';
import { MainModule } from './core/main/main.module';
/** Components */
import { AppComponent } from './app.component';
import { LoginComponent } from './core/login/login.component';
/** Environment */
import { BydRuntimeLoader } from '@envs/byd-runtime.loader';

import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeCs from '@angular/common/locales/cs';

registerLocaleData(localePl);
registerLocaleData(localeEs);
registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeCs);

@NgModule({
  declarations: [AppComponent, LoginComponent],
  imports: [
    DsLibCommonModule,
    BrowserAnimationsModule,
    AppModuleRouting,
    DsLibLoginFormModule,
    HttpClientModule,
    MainModule,
    ChartsModule,
    DsLibSnackbarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: BydTranslateLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BydRuntimeModule.forRoot(),
    BydCoreServiceModule.forRoot([
      {
        provide: BYD_API_INJECTION_TOKEN,
        useFactory: BydRuntimeLoader.roazhonConfigLoaderFn,
        deps: [BydRuntimeService],
        multi: true,
      },
      {
        provide: BYD_API_INJECTION_TOKEN,
        useFactory: BydRuntimeLoader.bimDataConfigLoaderFn,
        deps: [BydRuntimeService],
        multi: true,
      },
    ]),
    BydTranslateModule.forRoot({ language: BydLocalStorage.getItem('lang') }),
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: DsPaginatorService, deps: [TranslateService] },
    { provide: TRANSLATIONS_TOKEN, useValue: [TRANSLATIONS] },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BydAuthInterceptorService,
      multi: true,
    },
    DsLoaderInterceptorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DsLoaderInterceptorService,
      multi: true,
    },
    DsErrorsInterceptorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DsErrorsInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
